import { useMemo } from "react";

import {
  Box,
  HStack,
  Heading,
  Container,
  Breadcrumb,
  BreadcrumbItem,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
import PartialEarn from "./PartialEarn";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import constant from "config/constant";
import { useLocation } from "react-router-dom";

export default function Staking(props) {
  const currentPage = "Earn";

  const { search } = useLocation();

  const urlQueries = useMemo(() => new URLSearchParams(search), [search]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="bcpl">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <HStack>
                <Heading fontSize="3xl">Earn</Heading>
                {/* {isLoading && (
                  <CircularProgress
                    ml="20px !important"
                    isIndeterminate
                    color="var(--primary)"
                    size="20px"
                  />
                )} */}
              </HStack>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/earn">Earn</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to={`/dashboard/earn/staking`}>
                    Staking
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <PartialEarn
              coin={
                urlQueries.get("coin") ?? constant.supportedStakableCoins[0]
              }
              availableCoins={constant.supportedStakableCoins}
            />
          </Container>
        </Box>
      </Box>
    </Box>
  );
}
